import { Daisy as Spinner } from '@/ds-components/Spinner';

import styles from './index.module.scss';

function AppLoading() {
  return (
    <div className={styles.container}>
      <h1>Sagebridge</h1>
      <Spinner />
    </div>
  );
}

export default AppLoading;
